"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderSubmitted = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _formatters = require("formatters");

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp, _class3, _descriptor8, _temp2;

var OrderSubmittedPage = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(OrderSubmittedPage, _Component2);

  function OrderSubmittedPage() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, OrderSubmittedPage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(OrderSubmittedPage)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(OrderSubmittedPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement(OrderSubmitted, this.content));
    }
  }]);
  return OrderSubmittedPage;
}(_react.Component), _temp2), (_descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = OrderSubmittedPage;
var OrderSubmitted = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(OrderSubmitted, _Component);

  function OrderSubmitted() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, OrderSubmitted);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(OrderSubmitted)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "clientName", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderNumber", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderDate", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderedBy", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "poRefNumber", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderAmount", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderNotes", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(OrderSubmitted, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "orderSubmittedHeader"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, _react.default.createElement("div", {
        className: "order-review-header"
      }, _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "details-container"
      }, _react.default.createElement("h3", {
        className: "sub-header"
      }, this.clientName), _react.default.createElement("h1", null, "Order Submitted"), _react.default.createElement("h3", null, "Please note that this is an order requuest only. Official delivery slip and invoice to follow. If you have any questions about your order, please call us at 877-605-7665 or by email at", ' ', _react.default.createElement("a", {
        href: "mailto:sales@thepoolandspahouse.com"
      }, "sales@thepoolandspahouse.com"), ".")))))), _react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "6190834d989368f4a58a9e9f0a018514"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, _react.default.createElement("div", {
        className: "order-information"
      }, _react.default.createElement("h3", {
        className: "sub-header"
      }, "Order Information"), _react.default.createElement("br", null), _react.default.createElement("p", null, "Order #", this.orderNumber), _react.default.createElement("h1", {
        style: {
          marginTop: '0px'
        }
      }, new Date(this.orderDate).format('F j, Y')), _react.default.createElement("p", null, "by ", this.orderedBy, this.poRefNumber ? " - P.O. ".concat(this.poRefNumber) : ''), _react.default.createElement("br", null), _react.default.createElement("p", null, "Order Total"), _react.default.createElement("h1", {
        style: {
          marginTop: '0px'
        }
      }, (0, _formatters.formatPrice)(this.orderAmount, true)), _react.default.createElement("br", null), _react.default.createElement("hr", null), this.orderNotes && _react.default.createElement(_react.Fragment, null, _react.default.createElement("h3", {
        className: "sub-header"
      }, "Comment"), _react.default.createElement("p", null, this.orderNotes), _react.default.createElement("hr", null)), _react.default.createElement("h3", {
        className: "sub-header"
      }, "What would you like to do next?"), _react.default.createElement("ul", null, _react.default.createElement("li", null, _react.default.createElement("a", {
        href: ""
      }, "ProSite Home")), _react.default.createElement("li", null, _react.default.createElement("a", {
        href: "catalog/PRODUCTS/Frequently-Ordered"
      }, "Place Another Order")), _react.default.createElement("li", null, _react.default.createElement("a", {
        href: "pastorders"
      }, "View Past Order")), _react.default.createElement("li", null, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.doLogout
      }, "Log Out")))))));
    }
  }, {
    key: "doLogout",
    value: function doLogout() {
      _SiteLayout.default.current.logout();
    }
  }]);
  return OrderSubmitted;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "clientName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderDate", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderedBy", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "poRefNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderAmount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderNotes", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doLogout", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doLogout"), _class.prototype)), _class);
exports.OrderSubmitted = OrderSubmitted;